import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { UnidadeNegocioMultiselectComponent } from './unidade-negocio-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        UnidadeNegocioMultiselectComponent
    ],
    exports: [
        UnidadeNegocioMultiselectComponent
    ]
})
export class UnidadeNegocioMultiselectModule { }
